
import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { useAuthContext } from "../../context/authContextGoTrue/authContext";

export default function AuthenticatedRoute({ children, ...rest }) {
  const { pathname, search } = useLocation();
  const { session } = useAuthContext();
  return (
    <Route {...rest}>
      {session ? (
        children
      ) : (
        <Redirect to={
          `/login?redirect=${pathname}${search}`
        } />
      )}
    </Route>
  );
}